import axios from '../api/axiosInstance';

export const fetchCustomerAddresses = (customerId) => {
  return axios.get(`/customers/${customerId}/addresses`);
};

export const createCustomerAddress = (customerId, data) => {
  return axios.post(`/customers/${customerId}/addresses`, data);
};

export const updateCustomerAddress = (customerId, addressId, data) => {
  return axios.patch(`/customers/${customerId}/addresses/${addressId}`, data);
};

export const deleteCustomerAddress = (customerId, addressId) => {
  return axios.delete(`/customers/${customerId}/addresses/${addressId}`);
};

export const setDefaultCustomerAddress = (customerId, addressId) => {
  return axios.patch(`/customers/${customerId}/addresses/${addressId}/default`);
};

